import { Dispatch } from "redux";
import { AxiosError, AxiosResponse } from "axios";
import { AppThunk } from "../../../CommunityStore";
import { getRequest } from "../../../../utils/httpRequest";
import {
  LOAD_TOOLS,
  LOAD_TOOLS_FAILURE,
  LOAD_TOOLS_SUCCESS,
  LoadToolsAction,
  LoadToolsSuccessAction,
  Tool,
  ToolActionTypes,
} from "../types";

export const loadTools = (): LoadToolsAction => ({
  type: LOAD_TOOLS,
});

export const loadToolsSuccess = (
  tools: Tool[]
): LoadToolsSuccessAction => ({
  type: LOAD_TOOLS_SUCCESS,
  payload: tools,
});

export const fetchTools =
  (): AppThunk => async (dispatch: Dispatch<ToolActionTypes>) => {
    dispatch({ type: LOAD_TOOLS });
    getRequest("/api/community/tools.json")
      .then((response: AxiosResponse) => {
        dispatch(loadToolsSuccess(response.data));
      })
      .catch((error: AxiosError<{ error: string }>) => {
        dispatch({ type: LOAD_TOOLS_FAILURE, payload: error.message });
      });
  };
